import { Link } from 'react-router-dom'
import { UserMenu } from './UserMenu'

/**
 * The 2px red rule across the top is the brand signature and replaces the
 * mockup's navy chrome. It is non-interactive by design — brand red never
 * appears on a control, because red is also the destructive colour
 * (docs/01-design-system.md §2.1).
 */
export function TopBar() {
  return (
    <header className="sticky top-0 z-30">
      <div className="h-[2px] w-full bg-brand-red" aria-hidden />
      <div className="flex h-14 items-center gap-3 border-b border-rule bg-surface pr-4">
        <Link
          to="/"
          className="flex h-full w-[224px] shrink-0 items-center gap-2.5 px-4"
          aria-label="The Hive — all clients"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-[4px] bg-brand-red font-head text-[13px] font-semibold text-white">
            WB
          </span>
          <span className="font-head text-[14px] font-semibold leading-4">
            The Hive
            <span className="block text-[11px] font-normal text-ink-faint">Waybetter Marketing</span>
          </span>
        </Link>

        <div className="ml-auto">
          <UserMenu />
        </div>
      </div>
    </header>
  )
}
